import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FilterPanelComponent } from '../../filter-panel.component';

export enum TariffCustomerType {
  NSLT = 'NSLT',
  SLT = 'SLT',
}

export enum TariffStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export interface TariffFilterOutput {
  selectedCustomerTypes: string[];
  selectedTariffStatuses: string[];
  tariffNameSearch: string;
}

@Component({
  selector: 'app-tariff-filter',
  standalone: true,
  imports: [CommonModule, NgFor, FormsModule, TranslateModule, FilterPanelComponent],
  templateUrl: './tariff-filter.component.html',
  styleUrl: './tariff-filter.component.scss',
})
export class TariffFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedCustomerTypes: string[] = [];
  @Input() selectedTariffStatuses: string[] = [];
  @Input() tariffNameSearch: string = '';

  @Output() applied = new EventEmitter<TariffFilterOutput>();

  readonly customerTypes = Object.values(TariffCustomerType);
  readonly tariffStatuses = Object.values(TariffStatus);

  draftCustomerTypes: string[] = [];
  draftTariffStatuses: string[] = [];
  draftNameSearch: string = '';

  get activeFilterCount(): number {
    return (
      this.selectedCustomerTypes.length +
      this.selectedTariffStatuses.length +
      (this.tariffNameSearch ? 1 : 0)
    );
  }

  ngOnInit(): void {
    this.reset();
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggle<T>(list: T[], item: T): T[] {
    return list.includes(item) ? list.filter((i) => i !== item) : [...list, item];
  }

  onApply(): void {
    this.applied.emit({
      selectedCustomerTypes: this.draftCustomerTypes,
      selectedTariffStatuses: this.draftTariffStatuses,
      tariffNameSearch: this.draftNameSearch,
    });
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftCustomerTypes = [...this.selectedCustomerTypes];
    this.draftTariffStatuses = [...this.selectedTariffStatuses];
    this.draftNameSearch = this.tariffNameSearch;
  }
}
